import { z, ZodType } from 'zod';
import { WidgetsName, WidgetType } from './common';
import { jFileLittle, jFileLittleSchema } from '../file';
import { zObject } from '../../util/zod';

export type WidgetSlide = {
    title: string;
    text: string;
    titleHeading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
    textColor?: string;
    opacityFilter?: number;
    opacityColor?: string;
    file?: jFileLittle;
};
export const widgetSlideSchema = zObject<WidgetSlide>({
    title: z.string(),
    text: z.string(),
    titleHeading: z.enum(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span']).optional(),
    textColor: z.string().optional(),
    opacityFilter: z.number().optional(),
    opacityColor: z.string().optional(),
    file: jFileLittleSchema.optional(),
});

export type WidgetArticleSliderContent = {
    slides?: WidgetSlide[];
    maxWidth?: number;
    loop?: boolean;
    useDots?: boolean;
    startAt?: number;
};
export const widgetArticleSliderContentSchema = zObject<WidgetArticleSliderContent>({
    slides: widgetSlideSchema.array().optional(),
    maxWidth: z.number().optional(),
    loop: z.boolean().optional(),
    useDots: z.boolean().optional(),
    startAt: z.number().optional(),
});

export type WidgetArticleSliderType = {
    name: WidgetsName.ArticleSlider;
    uniqid: string;
    content: WidgetArticleSliderContent;
};
export const widgetArticleSliderTypeSchema = zObject<WidgetArticleSliderType>({
    name: z.literal(WidgetsName.ArticleSlider),
    uniqid: z.string(),
    content: widgetArticleSliderContentSchema,
}) satisfies ZodType<WidgetType<WidgetArticleSliderContent>>;
